import { useEffect, useContext, useState } from "react";
import styleColor from "../../assets/kits/colors/colors.module.scss";
import CustomButton from "../../components/kits/custom-button/CustomButton";
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  DeliveryExpressIcon,
  CheckIcon,
  AddIcon,
} from "../kits/Icons/Icons";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import AddressItem from "../kits/addressListItem/AddressItem";
import { NavLink } from "react-router-dom";
import Drawer from "../../components/drawer/Drawer";
import Add from "../../pages/AddressManage/Add";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../services/useAxios";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import { isNumber } from "lodash";
import useWindowSize from "../../hooks/useWindowSize";

export default function YourAddress({}) {
  const auth = useContext(AuthenticationContext);
  const [selectedId, setSelectedId] = useState(-1);
  const [isOpen2, setIsOpen2] = useState(false);
  const [height, setHeight] = useState(617);
  const [component, setComponent] = useState(<></>);
  const [updaterAddress, setUpdaterAddress] = useState(false);
  const navigate = useNavigate();
  const { shoppingList, updateShoppingList } = useContext(
    ShoppingCartItemContext
  );
  const { execute: EditAddressApi } = useAxios("api/edit_cart_address");
  const [updater, setUpdater] = useState(false);
  const { id } = useParams();
  const windowSize = useWindowSize();
  const updateAddress = () => {
    setUpdaterAddress((prev) => !prev);
  };

  useEffect(() => {
    //اگر سبد خرید آدرس نداشت از آدرس پیشفرض خود کاربر استفاده میکند و بعد بررسی میکند که اگر سبد خرید آدرس دارد از آن استفاده کند
    let array = auth.userInfo.addresses.filter(
      (a) => a.is_default == 1 && a.status != -1
    );
    if (array.length > 0) {
      setSelectedId(array[0]["id"]);
    }

    let select = shoppingList.filter(
      (Item) => +Item.supplier_info.suppliers__id == id
    );
    console.log(select, "select");

    select.length > 0 &&
      select[0].user_Address.length > 0 &&
      setSelectedId(select[0].user_Address[0].id);
  }, [shoppingList, auth.userInfo.addresses.length]);
  useEffect(() => {
    windowSize.height > 670 ? setHeight(617) : setHeight("85%");
  }, [windowSize]);
  async function EditAddressFunc(AddressId) {
    await EditAddressApi({
      address_id: AddressId,
      user_id: auth.userInfo.id,
      supplier_id: id,
    }).then((res) => {
      if (res.status == 1) {
        auth.refreshAddresses().finally(() => {
          updateShoppingList();
        });
      }
    });
  }
  return (
    <>
      <div className="d-flex justify-content-between align-items-center  mr-b-16 pd-r-20 pd-y-8 pd-l-8">
        <div className="d-flex align-items-center">
          <button className="btn pd-0" onClick={() => navigate(-1)}>
            <ArrowRightIcon />
          </button>

          <span
            className="mr-r-8 title-h3-b"
            style={{ color: styleColor.gray_900 }}
          >
            {" "}
            آدرس شما{" "}
          </span>
        </div>
        <div>
          <button
            onClick={() => {
              setIsOpen2(true);
              setComponent(
                <Add
                  setHeight={setHeight}
                  setIsOpen2={setIsOpen2}
                  setUpdaterAddress={setUpdaterAddress}
                />
              );
            }}
            className="btn title-h5-m d-flex mr-l-8 border-0"
            style={{ color: styleColor.gray_900 }}
          >
            <AddIcon width="20px" height="20px" />
            <span className="mr-r-4">افزودن</span>
          </button>
        </div>
      </div>

      <div className=" pd-x-20">
        {selectedId &&
          auth.userInfo.addresses.map((item, index) => (
            <>
              <AddressItem
                id={item.id}
                title={item.title}
                address={item.address}
                selected={item.id == selectedId ? true : false}
                RadioBtnFunc={(id) => {
                  EditAddressFunc(id);
                  setSelectedId(parseInt(id));
                }}
                hasRadioBtn={true}
                item={item}
                updateAddress={updateAddress}
                buttonShow={false}
                underLine={true}
              />
              {index != auth.userInfo.addresses.length - 1 && (
                <div className="mr-y-16 separator-line" />
              )}
            </>
          ))}
      </div>
      <Drawer
        isOpen={isOpen2}
        onClose={() => setIsOpen2(false)}
        height={height}
      >
        <div className="demo-content pd-x-16">{component}</div>
      </Drawer>
    </>
  );
}
